import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app__form__error"
}


const __default__ = {
	name: 'InputError',
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
	errors: Object,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.errors)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})